<template>
    <div class="vod-webinar-player">
        <div class="vod-webinar-loading" v-if="loading">
            <ListLoader />
        </div>
        <div class="vod-video-placeholder" v-if="videoPlaceholder">
            <img @show="loading = false" :src="videoPlaceholder" alt="" />
        </div>
        <vimeo-player
            @loaded="loading = false"
            :options="{ responsive: true }"
            autoplay="true"
            :video-id="0"
            :video-url="vimeoURL"
            v-if="vimeoURL"
        />
    </div>
</template>

<script>
export default {
    props: {
        videoPlaceholder: String,
        vimeoURL: String
    },
    data() {
        return {
            loading: true
        }
    }
}
</script>
<style lang="scss" scoped></style>
